import { useState } from "react"
import { FullScreenModal } from "../../../utility/FullScreenModal"
import { SystemSS } from "../../../components/SystemSS"

export const FacilitiesBase = () => {
     const [showModal, setShowModal] = useState(false)
     const [modalContent, setModalContent] = useState({ contentType: '', category: '', index: 1 })
     const handleOpenModal = (contentType, category, index, maxIndex) => {
         setModalContent({ contentType, category, index, maxIndex })
         setShowModal(true)
     }
     const handleCloseModal = () => {
         setModalContent({ contentType: '', category: '', index: 0 })
         setShowModal(false)
     }
    return (
        <>
            {' '}
            <section className=''>
                <div className='flex justify-center '>
                    <img
                        className=''
                        alt='confine'
                        src={`${process.env.PUBLIC_URL}/images/system/system-facilities.webp`}
                    />
                </div>
                <div className='text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full md:w-4/5 px-4 md:px-0 mx-auto mt-12'>
                    <p>
                        On Marona and her companions’ base, Skullrock Island, your allies can manage the various <span className='text-pborange'>Facilities</span> to provide services. To unlock a new Facility, simply <span className='text-pborange'>create a unit of the required class</span> in Create Character.
                    </p>
                    <SystemSS
                        mediaItems={[
                            {
                                modalId: 'facilities',
                                index: 1,
                            },
                        ]}
                        handleOpenModal={handleOpenModal}
                    />{' '}
                    <p>
                        For example, there is a Shop where you can purchase items, as well as a Juice Bar, which allows you to distribute EXP amongst your allies. There are also other Facilities that allow you to strengthen your units, such as Dungeon Creation, Fusion, Awaken/Reincarnate, Titles, and more, offering near-limitless opportunities for enjoyment!
                    </p>{' '}<br/>
                    <p>
                        Additionally, when you increase the Shop’s level, the items available to purchase will  <span className='text-pborange'>receive an upgrade.</span> Other Facilities will improve as you level up your ally units, too. Be sure to create and raise many different units so you can put the various features of Skullrock Island to use and get the absolute most out of the game!
                    </p>
                </div>
            </section>{' '}
            <FullScreenModal
                showModal={showModal}
                modalContent={modalContent}
                setModalImage
                handleCloseModal={handleCloseModal}
                setModalContent={setModalContent}
                maxIndex={1}
            />
        </>
    )
                
}